import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Header from "./components/header/header";
import HomePage from "./components/homePage/homePage";
import AboutUs from "./components/aboutUs/aboutUs";
import ContactUs from "./components/contactUs/contactUs";
import Gallery from "./components/gallery/gallery";
import Blog from "./components/blog/blog";
import Footer from "./components/footer/footer";
import Login from "./dashboard/login/login";
import Register from "./dashboard/register/register";
import Results from "./components/results/results";
import Dashboard from "./dashboard/admin/admin";
import PhotographerGallery from "./components/gallery/photographerGallery";
import NewsAndFeatures from "./components/searchNews&Features/searchNews&Features";
import TermsOfUse from "./components/termsOfUse/termsOfUse";
import PrivacyPolicy from "./components/privacyPolicy/privacyPolicy";
import PageNotFound from "./components/404/404";
const isAuth = localStorage.getItem("isAuth") === "true";

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/about-us" component={AboutUs} />
        <Route exact path="/contact-us" component={ContactUs} />
        <Route exact path="/gallery" component={Gallery} />
        <Route exact path="/terms-of-use" component={TermsOfUse} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/blog/:id" component={Blog} />
        <Route exact path="/results" component={Results} />
        <Route
          exact
          path="/search-news-and-features"
          component={NewsAndFeatures}
        />
        <Route
          exact
          path="/photographer-gallery/:id"
          component={PhotographerGallery}
        />
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route
          exact
          path="/login"
          render={() => {
            return isAuth ? (
              <Redirect to="/dashboard" />
            ) : (
              <Redirect to="/login" />
            );
          }}
        />
        <Route path="*" component={PageNotFound} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
